class catalogMode {
  constructor() {
    this.catalogMode = false;
    this.priceSelector = '[data-price-toggle-vat]';
    this.init();
  }

  checkCatalogMode = () => {
    if (localStorage.getItem('catalogMode')) {
      this.catalogMode = JSON.parse(localStorage.getItem('catalogMode'));
    }

    // Check all elements that are showing prices
    document.querySelectorAll(this.priceSelector).forEach((elem) => {
      elem.style.visibility = 'visible';
      elem.classList.toggle('opacity-0', this.catalogMode);
    });
  };

  init = () => {
    this.checkCatalogMode();

    document.querySelectorAll('[name="catalogMode"]').forEach((elem) => {
      elem.checked = this.catalogMode === false;

      elem.addEventListener('change', (e) => {
        this.catalogMode = !e.target.checked;
        localStorage.setItem('catalogMode', this.catalogMode);
        this.checkCatalogMode();
      });
    });

    // Observe the body for changes
    const priceObserver = new MutationObserver((mutationList, observer) => {
      this.checkCatalogMode();
    });
    priceObserver.observe(document.querySelector('body'), {
      attributes: false,
      childList: true,
      subtree: true,
    });
  };
}

const catalogModeInit = new catalogMode();
